import type { ComponentProps } from 'react'

import type { ResultadoOffgrid as Resultado } from '../tipos'
import { num, pct, usd } from '../formato'
import { TablaLineas } from './TablasCotizacion'

const MODO: Record<Resultado['sistema']['modo'], string> = {
  kit: 'Kit cerrado',
  paneles: 'Con paneles (cantidades a mano)',
  respaldo: 'Solo respaldo, sin paneles',
}

/** El resultado de un off-grid: equipos y precios. Sin VAN ni TIR: sin red no hay ahorro. */
type EdicionCostos = ComponentProps<typeof TablaLineas>['costos']

export function ResultadoOffgrid({ resultado, alQuitar, costos }: { resultado: Resultado; alQuitar?: (codigo: string) => void; costos?: EdicionCostos }) {
  const { sistema: s, totales: t } = resultado
  return (
    <div className="resultado">
      <div className="indicadores">
        <div className="indicador">
          <span className="indicador-titulo">Total con IVA</span>
          <span className="indicador-valor">{usd(t.total)}</span>
          <span className="indicador-detalle">
            {usd(t.base_imponible)} sin IVA{t.valor_descuento > 0 ? ` · descuento ${pct(t.descuento_pct)}` : ''}
          </span>
        </div>
        <div className="indicador">
          <span className="indicador-titulo">Utilidad SunSmart</span>
          <span className="indicador-valor">{usd(t.utilidad)}</span>
          <span className="indicador-detalle">{pct(t.utilidad_pct)} sobre costo</span>
        </div>
      </div>

      <div className="tarjeta">
        <h2>Sistema</h2>
        <dl className="lista-datos">
          <dt>Tipo</dt>
          <dd>{MODO[s.modo]}</dd>
          {s.kit && (
            <>
              <dt>Kit</dt>
              <dd>{s.kit}</dd>
            </>
          )}
          {s.paneles > 0 && (
            <>
              <dt>Paneles</dt>
              <dd>
                {s.paneles}
                {s.panel ? ` × ${s.panel.nombre}` : ''} · {num(s.potencia_kwp)} kWp
              </dd>
            </>
          )}
          <dt>Inversor</dt>
          <dd>
            {s.inversores.map((i) => `${i.cantidad} × ${i.nombre}`).join(' + ')} · {num(s.potencia_inversor_kw)} kW
          </dd>
          <dt>Batería</dt>
          <dd>
            {s.baterias.map((b) => `${b.cantidad} × ${b.nombre}`).join(' + ')} · {num(s.capacidad_bateria_kwh)} kWh
          </dd>
        </dl>
        <p className="suave">Sin análisis financiero: un sistema sin red no tiene factura que ahorrar.</p>
      </div>

      <div className="tarjeta">
        <h2>Equipos y precios</h2>
        <TablaLineas lineas={resultado.lineas} totales={t} alQuitar={alQuitar} costos={costos} />
      </div>
    </div>
  )
}
